import { render, staticRenderFns } from "./ScheduleCohortTable.vue?vue&type=template&id=3f67cd9a"
import script from "./ScheduleCohortTable.vue?vue&type=script&lang=js"
export * from "./ScheduleCohortTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports